const safeMathLog = Math.log;
export function runIdToFrequency(runId) {
    return 2 + ~~(safeMathLog(runId + 1) * 0.4342944819032518);
}
